<template>
  <div class="container-right_sidebar">
    <h6 class="section-label mb-2 mt-2">
      {{ $t('chat.assign') }}
    </h6>

    <div class="update-label-container">
      <div style="display: flex">
        <FeatherIcon
          icon="UserIcon"
          size="20"
          class="mr-1"
        />
        <p>
          {{ $t("ticket.operator") }}: {{ activeChannel.assignedOperator || $t('ticket.Unassigned') }}

        </p>
      </div>
      <template v-if="activeChannel.status !== 'resolved' && activeChannel.status !== 'cancel'">
        <template v-if="!activeChannel.isAllowToAssign || (activeChannel.status !== 'pending' && activeChannel.status !== 'hold')">
          <!-- <FeatherIcon
          v-b-tooltip.hover
          :title="$t('ticket.change_assignee_ticket_required_access')"
          icon="ChevronDownIcon"
          size="24"
          style="color: #b9b9c3"
        /> -->
          <FeatherIcon
            v-b-tooltip.hover
            icon="Edit2Icon"
            size="18"
            style="opacity: 25%; cursor: not-allowed;"
            :title="$t('ticket.change_assignee_ticket_required_access')"
          />
        </template>
        <template v-else>
          <!-- <FeatherIcon
          icon="ChevronDownIcon"
          size="24"
          :class="
            openOperatorDropdown
              ? 'dropdown-icon-active'
              : 'dropdown-icon-inactive'
          "
          @click="handleOpenOperator"
        /> -->
          <FeatherIcon
            v-b-tooltip.hover
            icon="Edit2Icon"
            size="18"
            class="clickable-icon"
            :title="$t('button.assignOperator')"
            @click="handleOpenOperator"
          />
        </template>
      </template>

    </div>

    <div
      class="update-label-container"
    >
      <div style="display: flex">
        <FeatherIcon
          icon="FlagIcon"
          size="20"
          class="mr-1"
        />
        <p>
          {{ $t("ticket.status") }}: {{ $t(`status.${activeChannel.status}`) }}
        </p>
      </div>
      <!-- <FeatherIcon
        icon="ChevronDownIcon"
        size="24"
        :class="
          openStatusDropdown ? 'dropdown-icon-active' : 'dropdown-icon-inactive'
        "
        @click="handleOpenStatus"
      /> -->
      <template v-if="activeChannel.status !== 'resolved' && activeChannel.status !== 'cancel'">
        <FeatherIcon
          v-if="!activeChannel.isAllowToUpdate || (activeChannel.status == 'pendingPrice' && !$can('manage', 'manage-service-price'))"
          v-b-tooltip.hover
          icon="Edit2Icon"
          size="18"
          style="opacity: 25%; cursor: not-allowed;"
          :title="$t('ticket.update_status_ticket_required_access')"
        />
        <FeatherIcon
          v-else
          v-b-tooltip.hover
          icon="Edit2Icon"
          size="18"
          class="clickable-icon"
          :title="$t('button.updateStatus')"
          @click="handleOpenStatus"
        />
      </template>
    </div>

    <!-- <assign-operator-modal
      ref="assignOperatorModal"
    />

    <update-status-modal
      ref="updateStatusModal"
    /> -->
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import { BFormSelect, BTooltip } from 'bootstrap-vue'
import useTicketStore from '@/store-pinia/useTicketStore'
import useRoleStore from '@/store-pinia/useRoleStore'
import Repository from '@/repositories/RepositoryFactory'
import AssignOperatorModal from './components/AssignOperatorModal.vue'
import UpdateStatusModal from './components/UpdateStatusModal.vue'

const OperatorRepository = Repository.get('operator')

export default {
  components: {
    BFormSelect, BTooltip, AssignOperatorModal, UpdateStatusModal,
  },
  props: {
    activeChannel: {
      type: Object,
      default: () => {},
    },
    // status: {
    //   type: String,
    //   default: '',
    // },
    // data: {
    //   type: Object,
    //   default: () => ({
    //     assignName: 'assignName',
    //     assignId: 'assignId',
    //     status: 'status',
    //     priorityLevel: 'priority',
    //   }),
    // },
  },
  data() {
    return {
      operators: [],
      options: [
        { label: 'status.pending', value: 'pending' },
        { label: 'status.processing', value: 'processing' },
        { label: 'status.hold', value: 'hold' },
        { label: 'status.completed', value: 'completed' },
      ],
    }
  },
  computed: {
    computedOptions() {
      if (this.activeChannel.status === 'pending') {
        return this.options.filter(option => option.value !== 'completed')
      } if (this.activeChannel.status === 'processing') {
        return this.options.filter(option => option.value !== 'pending')
      } if (this.activeChannel.status === 'hold') {
        return this.options.filter(option => option.value !== 'pending' && option.value !== 'completed')
      } if (this.activeChannel.status === 'completed') {
        return [{ label: 'status.completed', value: 'completed' }]
      }

      return this.options
    },
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.openOperatorDropdown = false
        this.openStatusDropdown = false
      }
    },
  },
  mounted() {
    // fetch operators
  },
  methods: {
    handleOpenOperator() {
      // this.$refs.assignOperatorModal.show(this.activeChannel)
      this.$emit('open-assign-operator-modal')
    },
    handleOpenStatus() {
      // this.$refs.updateStatusModal.show(this.activeChannel)
      this.$emit('open-update-status-modal')
    },
  },
  setup() {
    // const roleStore = useRoleStore()
    const openOperatorDropdown = ref(false)
    const openStatusDropdown = ref(false)
    const openPriorityDropdown = ref(false)
    const selectOperator = ref('')
    const selectStatus = ref('')

    // const ticketStore = useTicketStore()
    // const priorityLabel = computed(() => {
    //   let result = ''
    //   if (props.data.priorityLevel === 1) result = 'ticket.low'
    //   if (props.data.priorityLevel === 2) result = 'ticket.high'
    //   if (props.data.priorityLevel === 3) result = 'ticket.medium'
    //   if (props.data.priorityLevel === 4) result = 'ticket.urgent'
    //   if (props.data.priorityLevel === 0) result = 'ticket.unassigned'
    //   return result
    // })
    // const statusLabel = computed(() => {
    //   let result = ''
    //   if (props.data.status === 1) result = 'ticket.open'
    //   if (props.data.status === 2) result = 'ticket.resolved'
    //   if (props.data.status === 3) result = 'ticket.pending'
    //   return result
    // })
    // const statusList = [
    //   {
    //     text: 'ticket.open',
    //     value: 1,
    //   },
    //   {
    //     text: 'ticket.resolved',
    //     value: 2,
    //   },
    //   {
    //     text: 'ticket.pending',
    //     value: 3,
    //   },
    // ]
    // const priorityList = [
    //   {
    //     text: 'ticket.low',
    //     value: 1,
    //   },
    //   {
    //     text: 'ticket.high',
    //     value: 2,
    //   },
    //   {
    //     text: 'ticket.medium',
    //     value: 3,
    //   },
    //   {
    //     text: 'ticket.urgent',
    //     value: 4,
    //   },
    // ]
    // const statusForm = ref(props.data.priorityLevel)

    function handleSelectDropdownItem(payload, operatorName) {
      selectOperator.value = operatorName
      // console.log('testing selectOperator', selectOperator.value)
      // ticketStore.updateTicketAsync(payload)
      openOperatorDropdown.value = false
      openStatusDropdown.value = false
      openPriorityDropdown.value = false
    }

    function handleSelectDropdownItemStatus(payload, statusName) {
      selectStatus.value = statusName
      // console.log('testing selectStatus', selectStatus.value)
      // ticketStore.updateTicketAsync(payload)
      openOperatorDropdown.value = false
      openStatusDropdown.value = false
      openPriorityDropdown.value = false
    }

    function handleSelectDropdownItemPriority(payload, priorityName) {
      selectStatus.value = priorityName
      // console.log('testing selectStatus', selectStatus.value)
      // ticketStore.updateTicketAsync(payload)
      openOperatorDropdown.value = false
      openStatusDropdown.value = false
      openPriorityDropdown.value = false
    }

    return {
      // statusForm,
      // ticketStore,
      // priorityLabel,
      // statusLabel,
      // statusList,
      openStatusDropdown,
      openOperatorDropdown,
      openPriorityDropdown,
      selectOperator,
      selectStatus,
      // priorityList,
      // roleStore,
      handleSelectDropdownItem,
      handleSelectDropdownItemStatus,
      handleSelectDropdownItemPriority,
    }
  },
}
</script>

<style lang="scss" scoped>
.label-container {
  //font-weight: bold;
}

.clickable-icon {
  cursor: pointer;
}

.header-subtitle {
  font-size: 0.85em;
  color: gray;
}

.label-container {
  display: flex;
  gap: 1em;
}

.update-label-container {
  @extend .label-container;
  justify-content: space-between;
  position: relative;
}

.select-container {
  position: relative;
  display: flex;
  justify-content: space-between;
}

.select-option-container {
  position: absolute;
  width: 100%;
  top: 100%;
  background: white;
  box-shadow: 0 5px 25px rgba(47, 47, 47, 0.1);

  //opacity: 0;
  //visibility: hidden;
  transition: all 0.3s ease-in-out;

  &:hover {
    //opacity: 1;
    //visibility: visible;
  }
}

.dropdown-update-option {
  z-index: 1;
  position: absolute;
  width: 100%;
  top: 100%;
  background: white;
  box-shadow: 0 5px 25px rgba(47, 47, 47, 0.1);
  transition: all 0.3s ease-in-out;

  .dropdown-update-option-item {
    margin: unset;
    padding: 0.5em 1em;
    cursor: pointer;

    &:hover {
      background: #b876af;
      color: white;
    }
  }
}

.dropdown-menu-active {
  opacity: 1;
  visibility: visible;
}

.dropdown-menu-inactive {
  opacity: 0;
  visibility: hidden;
}

.select-option {
  margin: 0;
  padding: 0.5em 1em;

  &:hover {
    cursor: pointer;
    background-color: #b366a9;
    color: white;
  }
}

.dropdown-icon {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.dropdown-icon-active {
  @extend .dropdown-icon;
  transform: rotate(180deg);
}

.dropdown-icon-inactive {
  @extend .dropdown-icon;
  transform: rotate(0deg);
}

.container-right_sidebar {
}

.select-assign {
  display: flex;
  cursor: pointer;
  align-items: center;
}

.select-assign__active {
  @extend .select-assign;
  //background: #9f6096;
  background: #F2F0F7;
  color:#9f6096;
  // padding-left: 1rem !important;
  cursor: not-allowed !important;
  //color: #fff;
  //@hover:{
  //  background: #F2F0F7;
  //  color:#9f6096;
  //}
}

.select-assign__inactive {
  @extend .select-assign;

  &:hover {
    background: whitesmoke;
  }
}

// element.style {
//   border: 1px solid #9f6096;
// }

.dropdown-update-option {
  background: white;
  box-shadow: 0 5px 25px rgb(47 47 47 / 10%);
  border: 1px solid #9f6096;
  max-height: 200px;
  overflow-y: scroll;

}
</style>
